import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useAttributeList = guid => {
  const [loading, setLoading] = useState(true);
  const [attributeList, setAttributeList] = useState([]);
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getAttributeList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get(`SettingProduct/CoddingAttribute/List?Guid=${guid}`, { params })
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          setAttributeList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              title: element.display,
              value: element.value,
            }));

            return { ...prev, [params?.page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getAttributeList, loading, attributeList, pageRef];
};

export default useAttributeList;
